import C from "../constants";

export default (store) => (next) => (action) => {
  next(action);
  const state = store.getState();

  localStorage.setItem(
    C.APP_NAME,
    JSON.stringify({
      auth: {
        token: state.auth.token,
        user: state.auth.user,
      },
      router: state.router,
    })
  );
};
